import { create } from "zustand"

const useViewModeStore = create((set) => ({
  isViewMode: false,
  viewingAs: null, // { uid, displayName, email, photoURL, roles, firestoreData }

  enterViewMode: (userData) =>
    set({
      isViewMode: true,
      viewingAs: userData,
    }),

  exitViewMode: () =>
    set({
      isViewMode: false,
      viewingAs: null,
    }),
}))

export default useViewModeStore
